import { Injectable } from '@angular/core';
import { isUndefined } from 'util';
import { AppService } from 'src/app/app.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

export interface QueueCondition {
  queueConditionId: string;
  field: string;
  operation: string;
  value: string
}
export interface Queue {
  queueId: string;
  name: string;
  description: string;
  role: string;
  priority: number;
  conditions: QueueCondition[]
}

@Injectable({
  providedIn: 'root'
})
export class TaskManagementService {

  appData: any;

  constructor(
    private httpClient: HttpClient,
    private appService: AppService
  ) {
    this.appData = appService.settings;
  }

  getQueues(): Observable<any> {
    return this.httpClient.get<any>(`${this.appData.webApi}/taskmanagement/getQueues`)
  }
  getQueue(queueId: string): Observable<Queue>{
    return this.httpClient.get<Queue>(`${this.appData.webApi}/taskmanagement/queue/${queueId}`)
  }
  deleteQueue(queueId: string){
    return this.httpClient.delete(`${this.appData.webApi}/taskmanagement/queue/${queueId}`)
  }
  updateQueue(queue: Queue){
    return this.httpClient.put(`${this.appData.webApi}/taskmanagement/queue/${queue.queueId}`,queue);
  }
  addQueue(queue: Queue){
    return this.httpClient.post(`${this.appData.webApi}/taskmanagement/queue`,queue)
  }
  assignQueue(queueId: string, taskId: string){
    return this.httpClient.post(`${this.appData.webApi}/taskmanagement/queue/${queueId}/assign?idTask=${taskId}`,null)
  }
}
